import PlayInfoStrategy from './PlayInfoStrategy';
import PlayInfoCommon from './PlayInfoCommon';
import * as PlayInfo from './PlayInfo';
import * as BallPan from './BallPan';
import * as BallArea from './BallArea';
import * as SubPlay from './SubPlay';
import * as PlayRuleInfo from './PlayRuleInfo';
import * as PlayExt from './PlayExt';
import * as ChartInfo from './ChartInfo';

export class ConfigUtils {
  static gameConfig = Object.assign({}, PlayInfo.PlayInfo); // 游戏配置数据
  static dynamicPlayInfo = {};
  static ballcmdinfos = {};
  static dynamicSubPlay = {};
  static ballinfos = {};
  static channelCode = ''; // 推广渠道
  static aseqId = '7';

  // 游戏分类
  // static getGameCategory(payId) {
  //   if (fishingList.some(id => id === payId)) {
  //     return 3;
  //   } else if (chessList.some(id => id === payId)) {
  //     return 1;
  //   } else if (electronicList.some(id => id === payId)) {
  //     return 2;
  //   } else if (physicalEducation.some(id => id === payId)) {
  //     return 5;
  //   } else if (videoList.some(id => id === payId)) {
  //     return 6;
  //   } else if (CredEnvelope.some(id => id === payId)) {
  //     return 7;
  //   } else if (caipiao.some(id => id === payId)) {
  //     return 8;
  //   } else {
  //     return 4;
  //   }
  // }

  static deepCopy(obj) {
    if (obj === null) return null;
    if (obj instanceof RegExp) return new RegExp(obj);
    if (obj instanceof Date) return new Date(obj);
    if (typeof obj !== 'object') {
      return obj;
    }
    let t = new obj.constructor();
    for (let key in obj) {
      if (Object.hasOwnProperty.call(obj, key)) {
        t[key] = this.deepCopy(obj[key]);
      }
    }
    return t;
  }

  // 获得玩法信息
  static getPlayInfo(playId) {
    if (!Number(playId)) {
      return null;
    }
    let play = this.gameConfig[playId];
    if (play == null) {
      play = this.dynamicPlayInfo[playId];
    } else {
      if (play.state == null) {
        play.state = {};
      }
      play.id = Number(playId); // 主玩法
      if (play.base && !play.baseinit) {
        let base = PlayInfoCommon[play.base];
        if (base) {
          base = this.deepCopy(base);
          play = Object.assign(base, play);
        }
        if (play.icon == null) {
          play.icon = play.base;
        }
        play.baseinit = true;
        this.gameConfig[playId] = play;
      }
      if (play.icon == null) {
        play.icon = play.id;
      }
      if (play.default == null) {
        if (play.cat === 'PK10' || play.cat === 'XYFT' || play.cat === 'FC3D') {
          play.default = Number(play.id + '700');
        } else if (play.time === null) {
          play.default = Number(play.id);
          play.enable = true;
        } else {
          play.default = Number(play.id + '000');
        }
        if (play._play_cname) {
          if (play.cat === 'SSC') {
            play._default = Number(play.id + '103');
          } else if (play.cat === 'XYFT') {
            play._default = Number(play.id + '803');
          } else if (play.cat === 'K3') {
            play._default = Number(play.id + '701');
          }
        }
      }
      if (play.chartid == null) {
        play.chartid = play.id;
      }
    }
    // 动态生成玩法信息
    if (play == null && playId > 1000) {
      let strPlayId = playId + '';
      let mainPlayId = Number(strPlayId.substring(0, strPlayId.length - 3));
      let mainPlay = this.gameConfig[mainPlayId];
      let playBase = mainPlayId * 1000;
      if (mainPlay && mainPlay.strategy) {
        let strategy = PlayInfoStrategy[mainPlay.strategy];
        for (let id in strategy.plays) {
          let subPlayId = playBase + Number(id);
          let playInfo: any = this.deepCopy(strategy.plays[Number(id)]) || {};
          playInfo.id = subPlayId;
          this.dynamicPlayInfo[subPlayId] = playInfo;
        }
        play = this.dynamicPlayInfo[playId];
      }
    }
    if (play == null || Number(play.id) !== Number(playId)) {
      if (Number(playId) !== -1) {
        // console.error('没有找到相应玩法:' + playId)
      }
    }
    return play;
  }

  // 获得玩法的选号球信息
  static getBallCmdInfo(playId) {
    let play = this.getPlayInfo(playId);
    let ballinfo = this.ballcmdinfos[playId];
    if (ballinfo == null) {
      ballinfo = { areas: [] };
      let ballArea: any = null;
      if (play && play.area_id) {
        ballArea = BallArea.BallArea[play.area_id];
      }
      if (ballArea) {
        for (let i in ballArea.areas) {
          let area = ballArea.areas[i];
          let balls = {};
          balls['show'] = area.show;
          let ballplan = BallPan.BallPan[area.ballpanid];
          if (ballplan) {
            for (let j in ballplan.balls) {
              let ball = Object.assign({}, ballplan.balls[j]);
              ball.id += area.baseballid;
              if (area.basecmd) {
                ball.cmd = Number(ball.cmd) + area.basecmd + '';
              }
              balls[ball.cmd] = ball;
              if (Number(j) === 0) {
                balls['digit'] = ball.cmd.length;
              }
            }
          }
          ballinfo.areas.push(balls);
        }
      }
      this.ballcmdinfos[playId] = ballinfo;
    }
    return ballinfo;
  }

  static marginTenantPlayInfo(config) {
    if (config) {
      this.gameConfig = Object.assign(this.gameConfig, config);
    }
  }

  static updateMainPlayStates(states) {
    for (let k in this.gameConfig) {
      let play = this.getPlayInfo(k);
      if (states) {
        let gameState = states[play.id];
        if (gameState && gameState.play) {
          play.state = gameState.play.play_state;
          if (Number(gameState.play.play_state) !== 3) {
            play.enable = true;
          }
          play.strState = '';
          switch (Number(gameState.play.play_state)) {
            case 2:
              play.strState = '暂停销售';
              break;
            case 3:
              play.strState = '停止销售';
              break;
          }
        }
      }
    }
  }

  static getPlayConfig() {
    let dict = {};
    for (let k in this.gameConfig) {
      let play = this.getPlayInfo(k);
      if (play && play.enable) {
        dict[play.id] = play;
      }
    }
    return dict;
  }

  // 获得子玩法信息
  static getSubPlayInfo(playId, isXY = false) {
    let subInfo = this.dynamicSubPlay[playId];
    if (playId < 3000) {
      let play = this.getPlayInfo(playId);
      if (play && play.strategy) {
        let comSubInfo = SubPlay.SubPlay[play.strategy + (isXY ? 'XY' : '')];
        if (comSubInfo) {
          subInfo = this.deepCopy(comSubInfo);
          subInfo.subs = [];
          this.dynamicSubPlay[playId] = subInfo;
          let playIdBase = Number(playId + '000');
          for (let i in comSubInfo.subs) {
            let group = comSubInfo.subs[i];
            let groupNew = this.deepCopy(group) as any;
            groupNew.playids = [];
            for (let j in group.playids) {
              groupNew.playids.push(playIdBase + Number(group.playids[j]));
            }
            subInfo.subs.push(groupNew);
          }
        }
      }
    }
    return subInfo;
  }

  // 获得玩法的选号球信息
  static getBallInfo(playId) {
    let play = this.getPlayInfo(playId);
    let ballinfo = this.ballinfos[playId];

    if (ballinfo == null || (ballinfo.areas && !ballinfo.areas.length)) {
      ballinfo = { balls: {}, areas: [], playId: playId };
      let ballArea: any = null;
      if (play && play.area_id) {
        ballArea = BallArea.BallArea[play.area_id];
        ballinfo.area_id = play.area_id;
      }
      console.log(ballArea, 'ballAreaballAreaballAreaballAreaballArea');
      if (ballArea) {
        for (let i in ballArea.areas) {
          let area = ballArea.areas[i];
          let ids: any[] = [];
          let ballplan = BallPan.BallPan[area.ballpanid];

          if (ballplan) {
            for (let j in ballplan.balls) {
              let ball = Object.assign({}, ballplan.balls[j]);
              // 虚拟币跳过
              if (!play || !play.xnb) {
                ball.id += area.baseballid;
              }
              ball.areaidx = i;
              ball.isoption = area.isoption;
              if (area.basecmd) {
                ball.cmd = Number(ball.cmd) + area.basecmd + '';
              }
              ballinfo.balls[ball.id] = ball;
              ids.push(ball.id);
            }
          }
          let newArea = Object.assign({ ids: ids }, area);
          newArea.area_id = play.area_id;
          ballinfo.areas.push(newArea);
        }
      }
      this.ballinfos[playId] = ballinfo;
    }
    return ballinfo;
  }

  // 获得玩法规则信息
  static getPlayRuleInfo(playId) {
    let rule = null;
    let play = this.getPlayInfo(playId);
    if (play) {
      rule = PlayRuleInfo.PlayRuleInfo[play.rule_id];
    }
    return rule;
  }

  static getPlayExtItem(extid) {
    return PlayExt.PlayExt[extid];
  }

  static getChartConfig(cat, isApp = true) {
    let cfg = Object.assign({}, ChartInfo.chartConfigs[cat]);
    let trends = cfg.trends;
    cfg.trends = [];
    if (isApp) {
      for (let i in trends) {
        if (!trends[i].app_hide) {
          cfg.trends.push(trends[i]);
        }
      }
    } else {
      for (let i in trends) {
        if (!trends[i].pc_hide) {
          cfg.trends.push(trends[i]);
        }
      }
    }
    return cfg;
  }

  static getChartTrend3(cat, trendIdx, isApp = false) {
    let dict: any = null;
    let cfg = this.getChartConfig(cat, isApp);
    if (cfg && cfg.trends.length > trendIdx) {
      dict = Object.assign({}, cfg.trends[trendIdx]);
      let chart = cfg.trends[trendIdx];
      dict.winlen = cfg.winlen;
      dict.name = chart.name;
      dict.term_code_len = chart.term_code_len;
      dict.tabs = [];
      dict.tabDict = {};
      dict.cat = cat;
      if (isApp) {
        for (let i = 0; i < chart.tab_keys.length; i++) {
          let tabCfg = ChartInfo.chartTabs[chart.tab_keys[i]];
          let tab = Object.assign({ key: chart.tab_keys[i] }, tabCfg);
          if (!tab.app_hide) {
            let columns = Object.assign(ChartInfo.tableTitles[tabCfg.sub_title]);
            tab.columns = [];
            let idx = 0;
            for (let j = 0; j < columns.length; j++) {
              if (!columns[j].app_hide) {
                columns[j].col_idx = idx;
                tab.columns.push(columns[j]);
                idx++;
              }
            }
            dict.tabs.push(tab);
            dict.tabDict[chart.tab_keys[i]] = tab;
            tab.columns_dict = {};
            for (let j = 0; j < tab.columns.length; j++) {
              tab.columns_dict[tab.columns[j].key] = tab.columns[j];
            }
            delete tab.sub_title;
          }
        }
      } else {
        for (let i = 0; i < chart.tab_keys.length; i++) {
          let tabCfg = ChartInfo.chartTabs[chart.tab_keys[i]];
          let tab = Object.assign({ key: chart.tab_keys[i] }, tabCfg);
          if (!tab.pc_hide) {
            let columns = Object.assign(ChartInfo.tableTitles[tabCfg.sub_title]);
            tab.columns = [];
            let idx = 0;
            for (let j = 0; j < columns.length; j++) {
              if (!columns[j].pc_hide) {
                columns[j].col_idx = idx;
                tab.columns.push(columns[j]);
                idx++;
              }
            }
            dict.tabs.push(tab);
            dict.tabDict[chart.tab_keys[i]] = tab;
            tab.columns_dict = {};
            for (let j = 0; j < tab.columns.length; j++) {
              tab.columns_dict[tab.columns[j].key] = tab.columns[j];
            }
            delete tab.sub_title;
          }
        }
      }
    }
    return dict;
  }
}
